import { createContext, useContext } from "react";

/**
 * Контекст конфигурации формы (префикс для `data-testid`, и т.п.).
 * Предоставляется корневым компонентом {@link Form} при использовании формы с состоянием.
 */
interface FormConfigContextValue {
    /**
     * Префикс для автоматической генерации `data-testid` у полей.
     * Например, `testId="warehouse"` даёт полю `name="code"` значение `warehouse-field-code`.
     */
    testId?: string;
}

const FormConfigContext = createContext<FormConfigContextValue | null>(null);

/**
 * Провайдер конфигурации формы. Используется внутри {@link Form}.
 */
export const FormConfigProvider = FormConfigContext.Provider;

/**
 * Возвращает конфигурацию формы (например, `testId` для генерации `data-testid`).
 * Вызывать только внутри формы с состоянием (внутри {@link Form} с переданными `initialValues` / `onSubmit`).
 */
export function useFormConfig(): FormConfigContextValue | null {
    return useContext(FormConfigContext);
}
